import { render, staticRenderFns } from "./player-pergame.vue?vue&type=template&id=7dae5696&"
import script from "./player-pergame.vue?vue&type=script&lang=js&"
export * from "./player-pergame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports